const timeColumn = (field, headerName, width, editable, render) => {
    return {
        field: field,
        headerName: headerName,
        width: width,
        type: 'date',
        editable: editable,
        headerAlign: 'center',
        align: 'center',
        valueFormatter: (params) => {
            if (params.value !== null) {
                const value = new Date(params.value)
                const year = value.getFullYear()
                const month = value.getMonth() + 1 < 10 ? `0${value.getMonth() + 1}` : value.getMonth() + 1
                const day = value.getDate() < 10 ? `0${value.getDate()}` : value.getDate()
                return `${day}.${month}.${year}`
            } else {
                return ''
            }
        },
        renderCell: render
    }
}

export {timeColumn}